// @ts-nocheck
import { useEffect, useState, useRef, useReducer } from "react";
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from "primereact/dialog";
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import "../assets/functionalComponents/_dialog.scss"

function completedReducer(completed, action) {
    switch (action.type) {
        case "ADD":
            let value = completed.completedValue;
            value.push(action.value);
            return { completedValue: value };
        case "REMOVE":
            return { completedValue: [] }
        default:
            return;
    }
}

export const SurveyingComponents = (props: { Surveying: any; onHide: (arg0: string) => any; }) => {
    const [SurveyingList] = useState([
        { value: 0, label: "面積" },
        { value: 1, label: "地表長度" },
        { value: 2, label: "平面長度" },
        { value: 3, label: "空間長度" },
        { value: 4, label: "高度" },
    ])
    const [SurveyingType, setSurveyingType] = useState(0);
    const [completed, setCompleted] = useReducer(completedReducer, { completedValue: [] });
    const toast = useRef(null);

    useEffect(() => {
        window.main.OView.addEventListener("MeasureCompleted", measureCompleted);
    }, [])

    useEffect(() => {
        return () => {
            window.main.OView.removeEventListener("MeasureCompleted", measureCompleted);
        }
    }, [])

    const measureCompleted = (e) => {
        if (!e.success) {
            setSurveyingType(null);
            return;
        } else {
            let value = '';
            if (e.geo.area) {
                if (e.geo.area >= 1000000)
                    value = (e.geo.area / 1000000).toFixed(3) + "    平方公里";
                else
                    value = e.geo.area.toFixed(3) + "    平方公尺";
            }
            else if (e.geo.distance) {
                if (e.geo.distance >= 1000)
                    value = (e.geo.distance / 1000).toFixed(3) + "    公里";
                else
                    value = e.geo.distance.toFixed(3) + "    公尺";
            }
            else if (e.geo.height) {
                if (e.geo.height >= 1000)
                    value = (e.geo.height / 1000).toFixed(3) + "    公里";
                else
                    value = e.geo.height.toFixed(3) + "    公尺";
            }
            setCompleted({ type: "ADD", value: value });
            return;
        }
    }
    const surveyingStart = () => {
        switch (SurveyingType) {
            case 0:
                window.main.OView.abortMeasure();
                toast.current.show({ severity: 'info', summary: '測量提示', detail: '左鍵新增節點，雙擊左建結束測量' });
                window.main.OView.measureArea();
                break;
            case 1:
                window.main.OView.abortMeasure();
                toast.current.show({ severity: 'info', summary: '測量提示', detail: '左鍵新增節點，雙擊左建結束測量' });
                window.main.OView.measureSurfaceLength();
                break;
            case 2:
                window.main.OView.abortMeasure();
                toast.current.show({ severity: 'info', summary: '測量提示', detail: '左鍵新增節點，雙擊左建結束測量' });
                window.main.OView.measure2DLength();
                break;
            case 3:
                window.main.OView.abortMeasure();
                toast.current.show({ severity: 'info', summary: '測量提示', detail: '左鍵新增節點，雙擊左建結束測量' });
                window.main.OView.measureSpatialLength();
                break;
            case 4:
                window.main.OView.abortMeasure();
                toast.current.show({ severity: 'info', summary: '測量提示', detail: '左鍵開始測量' });
                window.main.OView.measureHeight();
                break;
            default:
                break;
        }
    }
    const surveyingClear = () => {
        window.main.OView.clearMeasure();
        setCompleted({ type: "REMOVE" });
    }

    return (
        <div>
            <Toast ref={toast} />
            <Dialog header="測量功能" visible={props.Surveying} modal={false} keepInViewport={false} onHide={() => props.onHide('Surveying')}>
                <div className="field grid">
                    <div className="col-12 md:col-6" style={{ alignSelf: 'center' }}>
                        <Dropdown className="inputfield w-full" inputId="coverDropdown" value={SurveyingType} options={SurveyingList} onChange={(e) => setSurveyingType(e.value)} optionLabel="label" showClear placeholder="選取測量類型。" />
                    </div>
                    <div className="col-12 md:col-6" style={{ alignSelf: "center", textAlign: "center" }}>
                        <span className="p-buttonset" style={{ width: "100%" }}>
                            <Button label="開始測量" icon="pi pi-check" onClick={surveyingStart} />
                            <Button label="清除測量" icon="pi pi-trash" onClick={surveyingClear} className="p-button-danger" />
                        </span>
                    </div>
                </div>
                {
                    completed?.completedValue.map(
                        (value) =>
                            <Card title="測量結果" style={{ width: '100%', marginBottom: '2em' }}>
                                <p className="m-0" style={{ lineHeight: '1.5' }}>{value}</p>
                            </Card>
                    )
                }
            </Dialog>
        </div>
    );
}